/**
 * Custom js to display homepage slider
 *
 * @since		09/21/2020
 * @author		<john@chatmandesign.com>
 * @link		http://chatmandesign.com
 */
(function($) {
    let homeSlider              = '.home-slider';
    let navArrows               = homeSlider + ' > .arrows';
    let content                 = homeSlider + ' .content-slider';
    let startSlideSelector      = '.slick-slide[data-slick-index="0"]';
    let containerOpacitySpeed   = 425;
    let slideSpeed              = 850;
    let longTransitionSpeed     = 1250;
    let slideAutoplaySpeed      = 4500;

    let arriveOptions = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };

    function slickStart() {
        $(content).on('init', function(event, slick) {
            $(homeSlider).removeClass('no-vis');
            let startSlide = $(content).find(startSlideSelector);
            startSlide.find('.container').addClass('show');
        })
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            speed: slideSpeed,
            cssEase: 'ease',
            adaptiveHeight: false,
            appendArrows: navArrows,
            fade: true,
            useCSS: false,
            autoplay: true,
            autoplaySpeed: slideAutoplaySpeed,
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            let slideCount = slick.$slides.length - 1; // account for 0 index

            /**
             * Slide Edge Cases
             * Want to minimize the jarring transition caused by slick on slider loops. 
             */ 
            let loopEndStart = currentSlide === slideCount && nextSlide === 0;
            let loopStartEnd = currentSlide === 0 && nextSlide === slideCount;

            // Check Slide Movement cases
            if( currentSlide === nextSlide) {
                return; // No slide change. 
            }

            let endSlideSelector        = '.slick-slide[data-slick-index="' + slideCount + '"]';
            let nextSlideSelector       = '.slick-slide[data-slick-index="' + nextSlide + '"]'; 
            let currentSlideSelector    =  '.slick-slide[data-slick-index="' + currentSlide + '"]'; 

            let nextSlideDOM        = $(content).find(nextSlideSelector);
            let currentSlideDOM     = $(content).find(currentSlideSelector);
            let startSlide          = $(content).find(startSlideSelector);
            let endSlide            = $(content).find(endSlideSelector);

            let next                = nextSlideDOM;
            let curr                = currentSlideDOM;

            if( loopEndStart ) {
                next = startSlide;
                curr = endSlide;

            } else if( loopStartEnd ) {
                next = endSlide;
                curr = startSlide;
            }

            let nextContainer = next.find('.container');
            let currContainer = curr.find('.container');

            curr.addClass('transition-out');
            next.addClass('transition-delay');

            setTimeout(function() {
                nextContainer.addClass('show');
            }, containerOpacitySpeed);

            setTimeout(function() {
                curr.removeClass('transition-out');
                currContainer.removeClass('show');
            }, slideSpeed);

            setTimeout(function() {
                next.removeClass('transition-delay');
            }, longTransitionSpeed); 

        });
    }

    // Once element is available initialize slick slider
    $(document).arrive(homeSlider, arriveOptions, slickStart);

})(jQuery);